module.exports = __webpack_public_path__ + "img/bg-3.1d680b9a.jpg";